import { Box, Typography } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import TableChartIcon from "@mui/icons-material/TableChart";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

type Attachment = {
  Id: number;
  AttachmentPath: string;
};

const SmallAttachmentPreview = ({ attachments = [] }: { attachments: Attachment[] }) => {

  const getFileName = (url: string) => url.split("/").pop() || "";

  const getExt = (fileName: string) =>
    fileName.split(".").pop()?.toLowerCase() || "";

  const getIcon = (ext: string) => {
    if (ext === "pdf") return <PictureAsPdfIcon sx={{ color: "#d32f2f" }} />;
    if (["doc", "docx"].includes(ext))
      return <DescriptionIcon sx={{ color: "#1976d2" }} />;
    if (["xls", "xlsx"].includes(ext))
      return <TableChartIcon sx={{ color: "#2e7d32" }} />;
    return <InsertDriveFileIcon sx={{ color: "#666" }} />;
  };

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      {attachments.map((item, index) => {
        const fileName = getFileName(item.AttachmentPath);
        const ext = getExt(fileName);

        return (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              border: "1px solid #ddd",
              borderRadius: "6px",
              padding: "8px 12px",
              minWidth: "130px",
              backgroundColor: "#f9f9f9",
            }}
          >
            {/* Image OR Icon */}
            {["jpg", "jpeg", "png"].includes(ext) ? (
              <img
                src={item.AttachmentPath}
                alt="file"
                style={{
                  width: 40,
                  height: 40,
                  objectFit: "cover",
                  borderRadius: 4,
                }}
                onError={(e: any) => {
                  e.target.style.display = "none";
                }}
              />
            ) : (
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                }}
              >
                {getIcon(ext)}
              </Box>
            )}

            {/* File Info */}
            <Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  color: "#000",
                  maxWidth: 140,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {fileName}
              </Typography>

              <Typography variant="caption" sx={{ color: "#666" }}>
                {ext}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default SmallAttachmentPreview;